<template>
  <div class="user-auth-box">
    <div class="user-auth-title">{{ propData.title }}</div>
    <div class="user-auth-message" v-html="propData.messageText"></div>
  </div>
</template>

<script>
//温馨提示， 效果看风险测评
export default {
  name: "warmPrompt",
  data () {
    return {};
  },
  props: {
    propData: {
      type: Object,
      default: {
        title: "风险测评提示",
        messageText: ""
      }
    }
  },
  methods: {}
};
</script>
<style lang="less" scoped>
.user-auth-box {
  width: 100%;
  height: 100%;
  .user-auth-title {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.16rem;
    margin: 0;
    font-weight: bold;
    line-height: 52px;
    color: #232323;
    // &::before,
    // &::after {
    //   content: "";
    //   display: block;
    //   width: 24px;
    //   height: 18px;
    // }
    // &::before {
    //   margin-right: 20px;
    //   background-image: url("~@img/home/05option/icon_zuo.png");
    // }
    // &::after {
    //   margin-left: 20px;
    //   background-image: url("~@img/home/05option/icon_you.png");
    // }
  }
  .user-auth-message {
    margin: 0 auto;
    padding: 5px 20px;
    font-size: 0.16rem !important;
    width: 100%;
    height: 90%;
    min-height: 350px;
    font-size: 30px;
    font-weight: 500;
    color: #4a4e53;
    line-height: 48px;
    background: #f5f7f8;
    border: 1px solid #dee1ea;
    box-sizing: border-box;
  }
}
</style>


// WEBPACK FOOTER //
// src/lib/ui/default/popup/src/content/warm_prompt.vue